import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import FontAwesomeIcon from './FontAwesomeIcon'
import clsx from 'clsx'

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    background: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
    display: 'inline-grid',
  },
  button: {
    padding: '7px 10px',
    '& > i': {
      color: theme.palette.grey[500],
    },
    cursor: 'pointer',
  },
  active: {
    background: theme.palette.grey['000'],
    borderRadius: 4,
    '& > i': {
      color: theme.palette.grey[700],
    },
    cursor: 'initial',
  },
  leftButton: {
    borderRight: `1px solid ${theme.palette.grey[200]}`,
  },
  centralButton: {
    borderLeft: `1px solid ${theme.palette.grey[200]}`,
    borderRight: `1px solid ${theme.palette.grey[200]}`,
  },
  rightButton: {
    borderLeft: `1px solid ${theme.palette.grey[200]}`,
  },
}))

interface Option {
  icon: string
  value: string
}

interface Props {
  options: Option[]
  value: string
  onChange: (value: string) => void
}

export default function OptionsToggler({ options, value, onChange }: Props) {
  const classes = useStyles()
  return (
    <div
      className={classes.container}
      style={{ gridTemplateColumns: `repeat(${options?.length}, 1fr)` }}
    >
      {options.map((option, idx) => (
        <div
          className={clsx(classes.button, value === option.value && classes.active, {
            [classes.leftButton]: value === option.value && idx === 0,
            [classes.centralButton]: value === option.value && idx > 0 && idx < options.length - 1,
            [classes.rightButton]: value === option.value && idx === options.length - 1,
          })}
          key={option.value}
          onClick={() => onChange(option.value)}
        >
          <FontAwesomeIcon>{option.icon}</FontAwesomeIcon>
        </div>
      ))}
    </div>
  )
}
